"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var GoogleMapsHelper_1 = __importDefault(require("./Entity/GoogleMapsHelper"));
var GoogleMapsHelperApi = /** @class */ (function () {
    function GoogleMapsHelperApi(session) {
        this.googleMapsHelperEntity = new GoogleMapsHelper_1.default(session);
    }
    GoogleMapsHelperApi.prototype.signUrl = function (url) {
        return this.googleMapsHelperEntity.signUrl(url);
    };
    return GoogleMapsHelperApi;
}());
exports.default = GoogleMapsHelperApi;
//# sourceMappingURL=GoogleMapsHelperApi.js.map